import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/ui/PageHeader';
import { AnomalyRegisterView } from '../components/receiving/AnomalyRegisterView';
import { useCapabilitiesStore } from '../stores/capabilitiesStore';
import { useAuthStore } from '../stores/authStore';

/** The anomaly register, from any desk — filter preset to the person's role (spec §8). */
export default function AnomaliesPage() {
  const { t } = useTranslation();
  const role =
    useCapabilitiesStore((s) => s.data?.role) ?? useAuthStore.getState().user?.role ?? '';
  const counter = ['COUNTER_AGENT', 'POLYVALENT', 'MANAGER', 'OWNER', 'WAREHOUSE_KEEPER'].includes(
    role
  );
  return (
    <div>
      <PageHeader title={t('rcv.ano.title')} description={t('rcv.ano.subtitle')} />
      <AnomalyRegisterView role={role} callListPath={counter ? '/counter/call-list' : undefined} />
    </div>
  );
}
